import {useCallback} from 'react'
import {useDispatch} from 'react-redux'
import axios from 'axios'
import config, {prefix} from '../../config'
import {GET_GROUP_INFO} from './actionTypes'
// import fetchData, {fetchContent} from '../../utils/fetch-data'
// import {useCurrentPageAPI} from '../getCurrentPage'
// import {useCoordsAPI} from '../getCoords'

const devEnv = process.env.NODE_ENV === 'development'

const cityAliasName = () => {
  if (devEnv) {
    return config.group
  }
  return window.theme.cityAlias
}

const useGroupInfoActions = () => {
  // const {currentPage} = useCurrentPageAPI()
  // const homePage = currentPage === 'homePage'
  // const cityPage = currentPage === 'cityPage' // const cityAlias = !homePage ? window.theme.cityAlias : false
  // const isGroupPage = currentPage === 'groupPage'

  const dispatch = useDispatch()


  const getGroupInfo = useCallback(() => {
    dispatch({
      type: GET_GROUP_INFO,
      payload: axios.get(`${prefix}/${cityAliasName()}/city-group-info?sc=1`),
    })
  }, [dispatch])
  return {getGroupInfo}
}

export default useGroupInfoActions
